export default __webpack_public_path__ + "static/media/phoneInHand.9ebd991f.png";